/* eslint-disable no-bitwise */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */
/* eslint-disable react/jsx-sort-props */
import Spinner from '@atlaskit/spinner';
import * as lodash from 'lodash';
import moment from 'moment';
import React, {
    FC,
    useContext,
    useEffect,
    useState,
    useRef
} from 'react';
import { useSelector } from 'react-redux';

import { accountService, callService2, accountService2, meetService } from '../../../../../service';
import { STATUS } from '../../../../../socket/config';
import { SocketContext, useSocket } from '../../../../../socket/socket.context';
import { goToRoomWithToken } from '../../../../../utils';
import {
    Icon,
    IconGroup,
    IconIncomingCall,
    IconMissedCall,
    IconOutgoingCall
} from '../../../base/icons';
import Card from '../atoms/Card';
import Filter from '../atoms/Filter';

import RecentCallItem from './RecentCalls/RecentCallItem';

export interface UserData {
    id: number,
    avatar?: string,
    phone: string,
    name?: string,
    time: string,
    isContact: boolean,
    createdDate: Date,
    callInfo: string,
    status: string
}
interface UserListProps {
    onChange: () => void,
    openAddContact: () => void,
    openCreateGroup?: () => void,
}
const UserList: FC<UserListProps> = ({ onChange, openAddContact, openCreateGroup }) => {
    const { user } = useSelector(state => state['features/settings']);
    const { room, conference } = useSelector(state => state['features/base/conference']);
    const [ isLoading, setIsLoading ] = useState(false);
    const [ error, setError ] = useState('');
    const [ recent, setRecent ] = useState([]);
    const [ contact, setContact ] = useState([]);
    const socketContext = useSocket();
    const { usersStatus, sendUserStatus } = useContext(SocketContext);
    const mountedRef = useRef(true);
    const [ selectedContacts, seSelectedContacts ] = useState(0);

    const fetchRecentCallData = async keywords => {
        setIsLoading(true);
        setError('');
        try {
            const response = await accountService2.getDataRecentCall(keywords);

            if (!mountedRef.current) return null;
            if (keywords && response.length === 0) {
                setError(`We couldn’t find anything for "${keywords}".`);
            }
            setRecent(response);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = lodash.debounce(keyword => {
        fetchRecentCallData(keyword);
    }, 500);

    // const handleCall = async item => {
    //     if (user.id && item.id) {
    //         socketContext.sendUserStatus(user.id, STATUS.BUSY);
    //         await callService2.createCallFromHistory(item.id)
    //         .then(async res => {

    //             const meeting = await meetService.createMeeting(res?.data?.callingHistory?.id, `${user.firstName} ${user.lastName}`,user.email, user.id);
    //             const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

    //             sendUserStatus(user.id, STATUS.BUSY);
    //             goToRoomWithToken(meetingrest.authRoom,meetingrest.token);
    //             sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}`, true);
    //             sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}-firstName`, item?.group?.name);
    //         });

    //     }
    // };
    const sortTime = (t1, t2, key) => {
        if (t1[key] > t2[key]) {
            return -1;
        }
        if (t1[key] < t2[key]) {
            return 1;
        }

        return 0;
    };
    const onSelectUser = (item, index) => {
        const raw = [ ...recent ];

        recent.map((re, key) => {
            if (key === index) {
                const selectContact = { ...re,
                    isContact: !re.isContact };

                raw.splice(index, 1, selectContact);
                setRecent(raw);
                if (selectContact.isContact) {
                    // eslint-disable-next-line no-shadow
                    seSelectedContacts(selectedContacts => selectedContacts + 1);
                } else {
                    // eslint-disable-next-line no-shadow
                    seSelectedContacts(selectedContacts => selectedContacts - 1);
                }
            }
        });
    };

    useEffect(() => {
        fetchRecentCallData('');
        (async () => {
            const data = await accountService.getDataContact();

            if (!mountedRef.current) return null;

            setContact(data);
        })();

        return () => {
            mountedRef.current = false;
        };
    }, []);

    const renderLabel = item => {
        const isToday = moment(item.createdDate).isSame(moment(), 'days');

        if (isToday) {
            return <div key = { `renderLabel-${item.id}` } className = 'o-user-list-item--label'>Today</div>;
        }

        const isYesterday = moment(item.createdDate).isSame(moment().subtract(1, 'days'), 'days');

        if (isYesterday) {
            return <div key = { `renderLabel-${item.id}` } className = 'o-user-list-item--label'>Yesterday</div>;
        }

        return <div key = { `renderLabel-${item.id}` } className = 'o-user-list-item--label'>{item.createdDate.locale('en').format('DD MMMM, YYYY')}</div>;
    };
    // const renderItem = (item, index) => {
    //     const status = usersStatus ? usersStatus[item?.id] : undefined;

    //     let iconCall = IconIncomingCall;
    //     let color = 'gray';

    //     switch (item?.callType) {
    //     case 'inbound': {
    //         iconCall = IconIncomingCall;
    //         break;
    //     }
    //     case 'outbound': {
    //         iconCall = IconOutgoingCall;
    //         break;
    //     }
    //     case 'missed': {
    //         iconCall = IconMissedCall;
    //         break;
    //     }
    //     }

    //     switch (status) {
    //     case STATUS.ONLINE : {
    //         color = 'green';
    //         break;
    //     }
    //     case STATUS.OFFLINE : {
    //         color = 'gray';
    //         break;
    //     }
    //     case STATUS.BUSY: {
    //         color = 'red';
    //         break;
    //     }
    //     case STATUS.DND: {
    //         color = 'yellow';
    //         break;
    //     }
    //     case undefined : {
    //         color = 'gray';
    //         break;
    //     }

    //     }

    //     return (
    //         <div className = { 'o-user-list-item--wrapper' }>
    //             <div
    //                 className = 'o-user-list-item-container mr-10'
    //                 key = { item.id }
    //                 onClick = { () => handleCall(item, index) }>
    //                 <div className = { 'dis-flex ali-center flex-1' }>
    //                     {item.isGroupCall ? (
    //                         <div
    //                             className = 'o-user-list-item-img o-user-list-item-group'>
    //                             <img
    //                                 height = '19'
    //                                 src = '../../../images/group-call.svg'
    //                                 width = '22' />
    //                         </div>
    //                     ) : item.avatar ? (
    //                         <div style = {{ display: 'flex' }}>
    //                             <img
    //                                 className = 'o-user-list-item-img'
    //                                 height = '48'
    //                                 src = { item.avatar }
    //                                 width = '48' />
    //                             <div
    //                                 className = { `o-user-list-item--status o-user-list-item--status--${color}` } />
    //                         </div>
    //                     ) : (
    //                         <div
    //                             className = 'o-user-list-item-img o-user-list-item-group'>
    //                             <img
    //                                 style = {{ borderRadius: '50%' }}
    //                                 src = 'https://dev.pantherconnect.me/images/gen-avatar.jpg' />
    //                             <div
    //                                 className = { `o-user-list-item--status o-user-list-item--status--${color}` } />
    //                         </div>
    //                     )}
    //                     { item?.group ? (
    //                         <div
    //                             className = 'o-user-list-item-name'>{item?.group?.name}</div>
    //                     )

    //                         : item.receivers.map(receiver => (<div
    //                             key = { receiver._id }
    //                             className = 'o-user-list-item-name'>
    //                             {receiver?.user ? receiver?.user?.firstName !== '' && receiver?.user?.firstName ? receiver?.user?.firstName : receiver?.phoneNumber : 'Deleted User' }
    //                         </div>))

    //                     }


    //                 </div>
    //                 {/* <Icon
    //                     className = { 'mr-10' }
    //                     size = { 24 }
    //                     src = { IconGroup } /> */}
    //                 <Icon
    //                     size = { 20 }
    //                     src = { iconCall } />
    //             </div>
    //             <button
    //                 className = 'o-phone-book-item-btn mt-10 ml-10'
    //                 onClick = { () => onSelectUser(item, index) }>
    //                 {
    //                     item.isContact
    //                         ? <div className = 'o-phone-book-item-dot' />
    //                         : null
    //                 }
    //             </button>
    //         </div>
    //     );
    // };
    const convertData = data => data.sort((r1, r2) => sortTime(r1, r2, 'createdDate')).map((item, index) => {
        if (moment(item.createdDate).format('DD/MM/YYYY')
            !== moment(recent[index - 1]?.createdDate).format('DD/MM/YYYY') || index === 0) {
            return (<>
                {
                    renderLabel(item)
                }
                {
                    (<RecentCallItem
                        key = { `RecentCallItem-${item.id}-${index}` }
                        item = { item }
                        index = { index }
                        onSelectUser = { onSelectUser }
                    />)
                }
            </>);
        }

        return  (<RecentCallItem
            key = { `RecentCallItem-${item.id}-${index}` }
            item = { item }
            index = { index }
            onSelectUser = { onSelectUser }
        />);
    });
    const initiateSelectedCall = async () => {
        if (!recent) {
            return;
        }
        const contactIds = [];
        const groupIds = [];

        const ringNames = [];
        const timeZone = moment.tz.guess();

        recent.forEach(l => {
            if (l.isContact) {
                // eslint-disable-next-line no-unused-expressions
                l?.contacts?.forEach(c => {
                    contactIds.push(c.user.id);
                });
                // eslint-disable-next-line no-unused-expressions
                l?.groups?.forEach(g => {
                    groupIds.push(g.group.id);
                });
                l.receivers.map(receiver => {
                    if (receiver?.user?.firstName) {
                        ringNames.push(receiver.user.firstName);
                    }               
                });

            }
        });

        let ringName;

        if (ringNames.length> 1) {
            console.log(ringNames.slice(0, 2).join(',')
.concat(',etc...'));
            ringName = ringNames.slice(0, 2).join(',')
.concat(',etc...');
        } else {
            console.log(ringNames.join(','));
            ringName = ringNames.join(',');
        }

        if (room) {
            //  v2
            await callService2.addMultipleUserFromContactIntoCall(room, contactIds, groupIds, timeZone);
        } else {
            // v2
            console.log(groupIds, contactIds);
            await callService2.createMultipleUserCall(groupIds, contactIds, timeZone)
                .then(async res => {
                    const meeting = await meetService.createMeeting(res?.data?.callingHistory?.id, `${user.firstName} ${user.lastName}`, user.email, user.id);
                    const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

                    sendUserStatus(user.id, STATUS.BUSY);
                    goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
                    sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}`, true);
                    sessionStorage.setItem(`ringing-${res.data?.callingHistory?.id}-firstName`, ringName);
                });

        }
    };

    return (
        <>
            <Card className = 'o-user-list'>
                <div className = { 'o-user-list--search' }>
                    <Filter
                        data = { recent }
                        onSearch = { handleSearch }
                        withSearchIcon = { true } />
                    {error && <span className = 'error-message-for-search'>{error}</span>}
                    <p className = 'o-user-list--title'>Recent Calls</p>
                </div>
                {selectedContacts > 1 && <button
                    className = 'o-phone-book-btn-call-selected'
                    onClick = { () => initiateSelectedCall() }>Call Selected</button> }
                <div className = 'o-user-list-item'>
                    {isLoading ? <div className = 'o-phone-book-list-spinner'>
                        <Spinner size = { 'large' } />
                    </div> : <>
                        <div>
                            {convertData(recent)}
                        </div>
                    </>}
                </div>
                <button
                    className = 'o-user-list-btn-sched'
                    onClick = { () => onChange(recent, false, 'recent') }>
                    Schedule a call
                </button>
            </Card>
        </>
    );
};

UserList.defaultProps = {
    onChange: () => {},
    openAddContact: () => {},
    openCreateGroup: () => {}
};

export default UserList;
